import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BookClassCommand, GroupClassDetailsModel, LocationResourceModel } from '@bayclubs/group-classes-employee-api';
import { HorizonToastService } from '@bayclubs/horizon';
import { FormService } from '@bayclubs/utils';
import { TranslateService } from '@ngx-translate/core';
import { GlobalEventsService } from '../../../../infrastructure/infrastructure.module';
import { GroupClassesApiService } from '../../../../shared/shared.module';

@Component({
    selector: 'app-add-participant',
    templateUrl: './add-participant.component.html',
    styleUrls: ['./add-participant.component.scss'],
    standalone: false
})
export class AddParticipantComponent implements OnInit {
    close: Function;
    public model: GroupClassDetailsModel;
    public resources: LocationResourceModel[];
    public resourceId: string;
    public requiresResources: boolean;
    public isLoaded = false;
    form: UntypedFormGroup;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private groupClassesApiService: GroupClassesApiService,
        private toast: HorizonToastService,
        private globalEventsService: GlobalEventsService,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.initiateForm();
        this.initializeResources();
    }

    initiateForm() {
        this.form = this.formBuilder.group({
            participant: [null, [Validators.required]]
        });
    }

    initializeResources() {
        if (this.model.isBookingRequiresSpecificResource === true) {
            this.groupClassesApiService
                .getLocationResources(this.model.id)
                .subscribe(r => this.onLocationResourcesLoaded(r.items));
        } else {
            this.isLoaded = true;
        }
    }

    initiateFormWithResources() {
        this.form = this.formBuilder.group({
            participant: [null, [Validators.required]],
            resource: [this.resourceId, [Validators.required]]
        });
    }

    onLocationResourcesLoaded(resources: LocationResourceModel[]) {
        this.resources = resources;
        this.resourceId = resources.length > 0 ? resources[0].id : null;
        this.requiresResources = true;
        this.isLoaded = true;

        this.initiateFormWithResources();
    }

    createRequest(): BookClassCommand {
        const member = this.form.get('participant').value;
        const command = <BookClassCommand>{
            groupClassId: this.model.id,
            memberId: member.id
        };
        if (this.requiresResources) {
            const resourceControl = this.form.controls['resource'];
            if (resourceControl) {
                command.locationResourceId = resourceControl.value;
            }
        }
        return command;
    }

    public get isMemberSearchValid(): boolean {
        const participant = this.form.controls['participant'];
        if (participant.disabled) {
            return true;
        } else {
            return !participant.touched || participant.valid;
        }
    }

    public onSave() {
        FormService.markFormAsTouched(this.form);
        if (this.form.valid) {
            const request = this.createRequest();
            this.groupClassesApiService.bookForMember(request).subscribe(x => {
                this.globalEventsService.onGroupClassUpdated$.emit({ id: this.model.id });
                this.toast.success(this.translate.instant('Utils.OperationOk'));
                this.close();
            });
        }
    }

    public onClose() {
        this.close();
    }
}
